<template>
  <div id="disney" v-visibility-change="visibilityChange">
    
    <journey v-show="isShowJourney"></journey>

    <transition name="fade">
      <finalScreen v-show="this.isShowFinalScreen"></finalScreen>
    </transition>


    <mainMenu></mainMenu>
    <shareMenu></shareMenu>

    <transition name="fade">
      <loading v-show="this.isShowLoadingScreen"></loading>
    </transition>


    <rotateScreen></rotateScreen>

  </div>
</template>

<script>
  import i18n from '@/language'
  import { store } from '../store'
  import loading from '@/components/loading'
  import shareMenu from '@/components/shareMenu'
  import mainMenu from '@/components/mainMenu'
  import journey from '@/components/journey'
  import finalScreen from '@/components/finalScreen'
  import rotateScreen from '@/components/rotateScreen'
  import * as commonFunction from '@/commonFunction/commonFunction'
  import router from '@/router'
  import visibility from '@/visibility';
  
  // import emptyComponent from '@/components/emptyComponent'

  export default {
    name: 'disney',
    components: {
      loading,
      shareMenu,
      mainMenu,
      journey,
      finalScreen,
      rotateScreen,
    },
    data () {
      return {
        isShowLoadingScreen : false,
        isShowFinalScreen : false,
        isShowJourney : false,
      }
    },
    created(){
      if (commonFunction.checkIsDesktop() || commonFunction.checkIsIpad()) {
        window.location.href = "#/desktop";
        gtag('event', 'page_view', { 
          'page_title': 'Desktop Page',
          'send_to': 'G-LPYZD9LDDW'
        });
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8227103/15tha0/pi_hk00-+standard'
        });
      }else{
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8227103/15tha0/pi_hk004+standard'
        });
      }
      
    },

    methods:{
      visibilityChange(evt, hidden) {
        // do something
        if(hidden == true){
          store.state.isMuted = true;
        }
      }
    },

    computed:{
      checkIsShowLoadingScreen(){return store.state.isShowLoadingScreen;},
      checkIsShowFinalScreen(){return store.state.isShowFinalScreen;},
      checkIsShowJourney(){return store.state.isShowJourney},
    },
    watch:{
      checkIsShowLoadingScreen(isShowLoadingScreen){
        this.isShowLoadingScreen = isShowLoadingScreen;
      },
      checkIsShowFinalScreen(isShowFinalScreen){
        this.isShowFinalScreen = isShowFinalScreen;
      },
      checkIsShowJourney(isShowJourney){
        this.isShowJourney = isShowJourney
      },
    },
    


  }
</script>
<style scoped>
  #disney{
    position: fixed;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/disney.vue